import { Divider, List, Paper, Stack } from '@mui/material'
import QuickSpotlight from '../../controls/spotlight/QuickSpotlight'
import RoutingManager from '../../routing/Routing'
import NavigationRoute from '../NavigationRoute'
import LeftSettings from './LeftSettings'
import UsersManager from '../../../managers/UsersManager'
import PermissionManager from '../../../managers/PermissionManager'
import { RoutePermissions } from '../../../managers/PermissionManager'

export default function LayoutLeftNavigation() {
    const testRouteNotifies = [{ route: 'workflow', notifies: 2 }]
    const currentUser = UsersManager.getCurrentUser()
    if (!currentUser) return null
    const allMenuRoutes = RoutingManager.getLeftMenuRoutes()
    const menuRoutesPerUser = allMenuRoutes.filter(route => {
        const requiredPermission = RoutePermissions[route.route]

        if (requiredPermission) {
            return PermissionManager.hasPermission(requiredPermission, currentUser)
        } else {
            return true
        }
    })

    return (
        <div className='layout-left-navigation'>
            <Paper elevation={1} square style={{ height: '100%', borderRadius: 0, border: 'none' }}>
                <Stack
                    p={1}
                    justifyContent='space-between'
                    height='100%'>
                    <Stack padding={1} justifyContent='center' alignItems='center'>
                        <QuickSpotlight />
                    </Stack>
                    <Stack
                        flex={1}
                        sx={{
                            overflow: 'auto'
                        }}>
                        <List>
                            {menuRoutesPerUser.map((x, i) => {
                                const notifies = testRouteNotifies.find(k => k.route === x.route)?.notifies
                                return (
                                    <NavigationRoute
                                        key={x.route + i}
                                        label={x.label}
                                        route={x.route}
                                        notifies={notifies}
                                    />
                                )
                            })}
                        </List>
                    </Stack>
                    <Stack paddingTop={1}>
                        <Divider />
                        <LeftSettings />
                    </Stack>
                </Stack>
            </Paper>
        </div>
    )
}
